import IBagReferences from "../models/bag-references";
import IBagTextures, { BagTextures } from "../models/bag-textures";
import ISceneModel from "../models/scene-model";

export default class References {
    private static _instance?: References;
    private _sceneReferences: ISceneModel | null = null
    private _bagReferences: IBagReferences | null = null
    private _bagTextures: IBagTextures
    private _bodyMaterial: THREE.ShaderMaterial | null = null
    private _edgeMaterial: THREE.ShaderMaterial | null = null
    private _sideMaterial: THREE.ShaderMaterial | null = null
    private _frontMaterial: THREE.ShaderMaterial | null = null
    private _ribbonMaterial: THREE.ShaderMaterial | null = null
    private _pocketMaterial: THREE.ShaderMaterial | null = null
    private _backMaterial: THREE.ShaderMaterial | null = null
    private _covertackColorMaterial: THREE.ShaderMaterial | null = null

    private constructor() {
        if (References._instance)
            throw new Error("Use Singleton.instance instead of new.");
        References._instance = this;
        this._bagTextures = new BagTextures()
    }

    static get instance() {
        return References._instance ?? (References._instance = new References());
    }

    setSceneReferences(sceneModel: ISceneModel) {
        this._sceneReferences = sceneModel
    }

    getSceneReferences(): ISceneModel {
        return this._sceneReferences!
    }

    setBagReferences(bagModel: IBagReferences) {
        this._bagReferences = bagModel
    }

    getBagReferences(): IBagReferences {
        return this._bagReferences!
    }

    setTexDefaultN(tex: THREE.Texture) {
        this._bagTextures.texDefaultN = tex
    }

    setTexBody(tex: THREE.Texture) {
        this._bagTextures.texBody = tex
    }

    setTexBodyN(tex: THREE.Texture) {
        this._bagTextures.texBodyN = tex
    }

    getBagTextures(): IBagTextures {
        return this._bagTextures!
    }

    setBodyMaterial(mat: THREE.ShaderMaterial) {
        this._bodyMaterial = mat
    }

    getBodyMaterial() : THREE.ShaderMaterial {
        return this._bodyMaterial!
    }

    setEdgeMaterial(mat: THREE.ShaderMaterial) {
        this._edgeMaterial = mat
    }

    getEdgeMaterial() : THREE.ShaderMaterial {
        return this._edgeMaterial!
    }

    setPocketMaterial(mat: THREE.ShaderMaterial) {
        this._pocketMaterial = mat
    }

    getPocketMaterial() : THREE.ShaderMaterial {
        return this._pocketMaterial!
    }

    setSideMaterial(mat: THREE.ShaderMaterial) {
        this._sideMaterial = mat
    }

    getSideMaterial() : THREE.ShaderMaterial {
        return this._sideMaterial!
    }

    setFrontMaterial(mat: THREE.ShaderMaterial) {
        this._frontMaterial = mat
    }

    getFrontMaterial() : THREE.ShaderMaterial {
        return this._frontMaterial!
    }

    setRibbonMaterial(mat: THREE.ShaderMaterial) {
        this._ribbonMaterial = mat
    }

    getRibbonMaterial() : THREE.ShaderMaterial {
        return this._ribbonMaterial!
    }

    setBackMaterial(mat: THREE.ShaderMaterial) {
        this._backMaterial = mat
    }

    getBackMaterial() : THREE.ShaderMaterial {
        return this._backMaterial!
    }

    setCovertackColorMaterial(mat: THREE.ShaderMaterial) {
        this._covertackColorMaterial = mat
    }

    getCovertackColorMaterial() : THREE.ShaderMaterial {
        return this._covertackColorMaterial!
    }
}
